<template>
  <div id="app" @click="menuOpen = false">
    <header id="nav" @click.stop>
      <div class="nav-content">
        <div class="logo fl">
          <img style="margin-top: 7px; height: 40px" src="https://vlebo.cn/skin/default/picture/logo2.png" />
        </div>
        <!-- PC 导航 -->
        <div class="fl pc-nav">
          <a class="link" :class="{ 'router-active': activeNavIndex === 1 }" @click="toNext('/index', 1)">主页</a>
          <a class="link" :class="{ 'router-active': activeNavIndex === 2 }" @click="toNext('/live', 2)">直播间</a>
          <a class="link" :class="{ 'router-active': activeNavIndex === 5 }" @click="toNext('/vip', 5)">会员专区</a>
          <a class="link" :class="{ 'router-active': activeNavIndex === 6 }" @click="toNext('/about', 6)">联系我们</a>
        </div>
        <div class="login fr pc-nav" v-if="user.isLogin">
          <img class="login-user" src="./assets/img/login-user.png" alt="" />
          <a class="link logout-link" @click="logout">退出</a>
        </div>
        <div class="login fr pc-nav" v-else>
          <a id="login" class="link" @click="toLogin">登录</a>
          |
          <a class="link" @click="toRegister" style="margin-left: 15px">注册</a>
        </div>
        <!-- 移动端汉堡按钮 -->
        <div class="hamburger mobile-nav" @click="menuOpen = !menuOpen">
          <span></span><span></span><span></span>
        </div>
      </div>
      <!-- 移动端下拉菜单 -->
      <div class="mobile-menu" v-show="menuOpen">
        <a class="m-link" :class="{ 'router-active': activeNavIndex === 1 }" @click="toNext('/index', 1)"><span>主页</span></a>
        <a class="m-link" :class="{ 'router-active': activeNavIndex === 2 }" @click="toNext('/live', 2)"><span>直播间</span></a>
        <!-- <a class="m-link" :class="{ 'router-active': activeNavIndex === 3 }" @click="toNext('/find', 3)"><span>发现音乐</span></a> -->
        <a class="m-link" :class="{ 'router-active': activeNavIndex === 4 }" @click="toNext('/recommend', 4)"><span>音乐推荐</span></a>
        <a class="m-link" :class="{ 'router-active': activeNavIndex === 5 }" @click="toNext('/vip', 5)"><span>会员专区</span></a>
        <a class="m-link" :class="{ 'router-active': activeNavIndex === 6 }" @click="toNext('/about', 6)"><span>联系我们</span></a>
        <div class="m-login" v-if="user.isLogin">
          <img class="login-user" src="./assets/img/login-user.png" alt="" />
          <a class="m-link" @click="logout">退出</a>
        </div>
        <div class="m-login" v-else>
          <a class="m-link" @click="toLogin">登录</a>
          <a class="m-link" @click="toRegister">注册</a>
        </div>
      </div>
    </header>
    <div style="margin-top: 60px">
      <router-view @showLogin="toLogin" />
    </div>
    <Footer />
    <Report />
    <Modal v-model="islogin" title="" ok-text="是" cancel-text="否" class-name="login-modal" width="384">
      <div slot="title"></div>
      <div class="content">
        <div class="title-box">登录</div>
        <div class="input-box">
          <Input v-model.trim="user.name" style="width: 304px; margin-bottom: 24px" autocomplete="off"
            placeholder="请输入用户名"></Input>
          <Input v-model.trim="user.password" :type="showLoginPwd ? 'text' : 'password'" style="width: 304px" autocomplete="off"
            placeholder="请输入密码">
            <Icon :type="showLoginPwd ? 'ios-eye-off' : 'ios-eye'" slot="suffix" @click.native="showLoginPwd = !showLoginPwd" style="cursor:pointer" />
          </Input>
        </div>
        <div class="btn-box">
          <div class="btn" @click="login">登录</div>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-model="isregister" title="" ok-text="是" cancel-text="否" class-name="login-modal register-modal"
      width="384">
      <div slot="title"></div>
      <div class="content">
        <div class="title-box">注册</div>
        <div class="input-box">
          <div class="require-box">
            <Input v-model.trim="registerUser.name" style="width: 304px" placeholder="请输入用户名"
              required></Input>
            <div class="require-icon">*</div>
          </div>
          <div class="input-hint" style="width: 304px; margin-top: 2px; margin-bottom: 22px">仅支持英文、数字和下划线</div>
          <div class="require-box">
            <Input v-model.trim="registerUser.phoneNum" style="width: 304px; margin-bottom: 24px" placeholder="请输入手机号"></Input>
            <div class="require-icon">*</div>
          </div>
          <div class="require-box">
            <div class="sms-input-row" style="width: 304px; margin-bottom: 24px">
              <Input v-model.trim="registerUser.smsCode" placeholder="请输入验证码" style="width: 176px"></Input>
              <Button type="primary" :disabled="registerCountdown > 0" @click="sendRegisterSms" size="default" style="margin-left: 10px; width: 104px">
                {{ registerCountdown > 0 ? registerCountdown + 's后重发' : '获取验证码' }}
              </Button>
            </div>
            <div class="require-icon">*</div>
          </div>
          <div class="require-box">
            <Input v-model.trim="registerUser.password" :type="showRegPwd ? 'text' : 'password'" style="width: 304px; margin-bottom: 24px"
              placeholder="请设置密码">
              <Icon :type="showRegPwd ? 'ios-eye-off' : 'ios-eye'" slot="suffix" @click.native="showRegPwd = !showRegPwd" style="cursor:pointer" />
            </Input>
            <div class="require-icon">*</div>
          </div>
          <div class="require-box">
            <Input v-model.trim="registerUser.passwordA" :type="showRegPwdA ? 'text' : 'password'" style="width: 304px; margin-bottom: 24px"
              placeholder="请确认密码">
              <Icon :type="showRegPwdA ? 'ios-eye-off' : 'ios-eye'" slot="suffix" @click.native="showRegPwdA = !showRegPwdA" style="cursor:pointer" />
            </Input>
            <div class="require-icon">*</div>
          </div>
          <div class="require-box">
            <Input v-model.trim="registerUser.trueName" style="width: 304px; margin-bottom: 24px"
              placeholder="请输入身份证姓名"></Input>
            <div class="require-icon">*</div>
          </div>
          <div class="require-box">
            <Input v-model.trim="registerUser.cardNum" style="width: 304px" placeholder="请输入身份证号"></Input>
            <div class="require-icon">*</div>
          </div>
        </div>
        <div class="btn-box">
          <Button type="primary" @click="register" :disabled="!agree">
            注册
          </Button>
        </div>
        <div class="promise-box">
          <Checkbox v-model="agree">
            我已阅读并同意
            <a href="https://b.vlebo.cn/agreement/agreement.html" target="_blank" style="color: #20a0ff;">《用户注册协议》</a>
            及
            <a href="https://b.vlebo.cn/agreement/agreement-policy.html" target="_blank" style="color: #20a0ff;">《隐私政策》</a>
          </Checkbox>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <!-- 开启青少年模式弹窗 -->
    <Modal v-model="showOpenTeenModal" title="开启青少年模式" class-name="teen-modal" width="380" :mask-closable="false">
      <div class="teen-form-row">
        <span class="teen-form-label">请设置监管人密码：</span>
        <Input v-model="newPassword" type="password" placeholder="请输入" style="width:180px"
          @keyup.enter.native="confirmOpenTeenMode" />
      </div>
      <div slot="footer">
        <Button @click="showOpenTeenModal = false; newPassword = ''">关闭</Button>
        <Button type="primary" @click="confirmOpenTeenMode">确认</Button>
      </div>
    </Modal>

    <!-- 青少年模式已开启状态弹窗 -->
    <Modal v-model="showTeenStatusModal" title="青少年模式已开启" class-name="teen-modal" width="380" :mask-closable="false">
      <div class="teen-status-text">
        您已开启青少年模式，已关闭打赏等功能，22:00-6:00点将停止服务，今日还可观看{{ teenRemainingTime }}，请合理安排时间！
      </div>
      <div slot="footer">
        <Button v-if="!isMinor" @click="openCloseTeenModal">解除青少年模式</Button>
        <Button type="primary" @click="showTeenStatusModal = false">我知道了</Button>
      </div>
    </Modal>

    <!-- 解除青少年模式弹窗 -->
    <Modal v-model="showCloseTeenModal" title="解除青少年模式" class-name="teen-modal" width="380" :mask-closable="false">
      <div class="teen-form-row">
        <span class="teen-form-label">请输入监管人密码：</span>
        <Input v-model="closePassword" type="password" placeholder="请输入" style="width:180px"
          @keyup.enter.native="confirmCloseTeenMode" />
      </div>
      <div slot="footer">
        <Button @click="showCloseTeenModal = false; closePassword = ''">关闭</Button>
        <Button type="primary" @click="confirmCloseTeenMode">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<style lang="scss">
html,
body {
  background-color: #eef1f6;
  min-height: 100%;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #eef1f6;
}

.clearfix:after {
  content: '\200B';
  display: block;
  height: 0;
  clear: both;
}

a:-webkit-any-link {
  text-decoration: none;
}

#nav {
  // padding: 30px;
  width: 100vw;
  height: 60px;
  line-height: 60px;
  background: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;

  .nav-content {
    max-width: 1000px;
    width: 100%;
    margin: auto;
    padding: 0 16px;
    box-sizing: border-box;

    .logo {
      float: left;
      width: 250px;
      height: 60px;
      text-align: left;
    }
  }

  a {
    font-weight: bold;
    color: #2c3e50;
    display: inline-block;
    height: 60px;
    margin: 0 14px;
    position: relative;

    &.router-active {
      color: #20a0ff;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: #20a0ff;
      }
    }
  }
}

.pc-nav {
  display: inline-block;
}

.hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  float: right;
  height: 60px;
  cursor: pointer;
  padding: 0 8px;

  span {
    display: block;
    width: 22px;
    height: 2px;
    background: #333;
    border-radius: 2px;
  }
}

.mobile-menu {
  display: none;
  flex-direction: column;
  background: #fff;
  padding: 8px 0 0;
  border-top: 1px solid #eee;
  box-shadow: 0 4px 8px rgba(0,0,0,0.06);

  .m-link {
    display: block;
    font-size: 15px;
    font-weight: bold;
    color: #2c3e50;
    cursor: pointer;
    text-align: left;

    &.router-active {
      color: #20a0ff;
      span {
        display: inline-block;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 100%;
          height: 2px;
          background: #20a0ff;
        }
      }
    }
  }

  .m-login {
    border-top: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 0;
  }
}

@media (max-width: 768px) {
  .pc-nav {
    display: none !important;
  }

  .hamburger {
    display: flex;
  }

  .mobile-menu {
    display: flex;
  }

  #nav {
    height: auto;

    .nav-content {
      height: 60px;
    }

    a.router-active::after {
      display: none;
    }
  }
}

.m-container {
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  text-align: left;
  padding: 0 16px;
  box-sizing: border-box;
}

.link:hover {
  color: #20a0ff !important;
}

.m-about .wechat-qr {
  width: 120px;
  height: 120px;
  vertical-align: bottom;
}

.m-about .wechat-qr {
  width: 120px;
  height: 120px;
  vertical-align: bottom;
}

.n-about-tit {
  color: #fff;
  height: 60px;
  line-height: 60px;
  font-size: 20px;
  padding-left: 20px;
  margin-top: 72px;
  margin-bottom: 25px;
  background-color: #22a4e5;
}

.n-content {
  color: #333;
  font-size: 18px;
  line-height: 32px;
}

.n-content .blue {
  color: #22a4e5;
}

.n-content .ans {
  color: #888;
}

.n-qa {
  margin-bottom: 40px;
}

.n-mktmap {
  position: relative;
}

.n-mktmap .map {
  width: 100%;
}

.n-mktmap .location {
  display: none;
  font-weight: 400;
  position: absolute;
  top: -39px;
  left: -28px;
  border-radius: 2px;
  background: #22a4e5;
  color: #fff;
  font-size: 12px;
  width: 51px;
  z-index: 1;
  padding: 6px;
  text-align: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.42);
}

.n-mktmap .location.show {
  display: inline-block;
}

.n-mktmap .location:before {
  top: 100%;
  left: 50%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-width: 4px;
  margin-left: -4px;
  margin-top: -1px;
  box-shadow: -3px 3px 3px 0 rgba(0, 0, 0, 0.4);
  border-color: transparent transparent #22a4e5 #22a4e5;
  transform-origin: 0 0;
  transform: rotate(-45deg);
}

.n-mktmap .dot {
  position: absolute;
  top: 286px;
  left: 723px;
  display: inline-block;
  width: 0;
  height: 0;
}

.n-mktmap .circle {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: #22a4e5;
  border-radius: 100%;
  overflow: visible;
  z-index: 1;
  cursor: pointer;
}

* {
  margin: 0;
  padding: 0;
}

div {
  box-sizing: border-box;
}

.link {
  color: #333;
}

.link:visited {
  color: #333;
}

.container {
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  text-align: left;
  padding: 0 16px;
  box-sizing: border-box;
}

header {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #fff;
  color: #333;
  font-size: 18px;
}

header .active {
  color: #20a0ff;
  position: relative;
}

header .active::after {
  position: absolute;
  color: #20a0ff;
  content: ' ';
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: #20a0ff;
}

a {
  text-decoration: none;
}

a:hover {
  color: #20a0ff !important;
}

a.link:hover {
  color: #20a0ff !important;
}

.logo {
  float: left;
  width: 250px;
  height: 60px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.link {
  cursor: pointer;
}

.ellipsis-2 {
  overflow: hidden;
  display: -webkit-box;
  word-break: break-all;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.clearfix:after {
  content: '\200B';
  display: block;
  height: 0;
  clear: both;
}

.clearfix {
  *zoom: 1;
}

/*IE/7/6*/
.banner {
  width: 100%;
  margin: 40px 0;
}

.tit {
  color: #333;
  padding-left: 10px;
  font-size: 18px;
  line-height: 20px;
  font-weight: normal;
  position: relative;
  border-left: 3px solid #20a0ff;
  margin-bottom: 15px;
}

.list {
  min-height: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #666;
  margin-bottom: 10px;
  overflow: hidden;
}

.list a {
  color: #666;
  display: inline-block;
  max-width: calc(100% - 130px);
}

.list a:hover {
  color: #20a0ff;
}

.time {
  float: right;
  color: #999999;
}

.slick-dotted.slick-slider {
  margin-bottom: 55px;
}

.slick-slide img {
  width: 100%;
}

.slick-prev {
  z-index: 8;
  left: 25px;
}

.slick-next {
  right: 25px;
}

@font-face {
  font-family: YouSheBiaoTiHei;
  src: url('./assets/font/YouSheBiaoTiHei.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
</style>
<style lang="scss">
.login {
  display: inline-flex;
  align-items: center;
  height: 60px;
}

.login-user {
  width: 32px;
  height: 32px;
  margin-top: 0;
  display: block;
}

.logout-link {
  margin-left: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #666;
}

.login-modal {

  .ivu-modal-header,
  .ivu-modal-footer,
  .ivu-modal-close {
    display: none;
  }

  .content {
    .title-box {
      text-align: center;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
    }

    .input-box {
      width: 304px;
      margin: 24px auto;
    }

    .btn-box {
      width: 304px;
      text-align: center;
      margin: 0 auto;
      height: 44px;
      line-height: 44px;
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;

      .btn {
        border-radius: 2px;
        background: #20a0ff;
        width: 100%;
        height: 100%;
      }
    }
  }
}

@media (max-width: 420px) {
  .ivu-modal-wrap .ivu-modal {
    width: 95vw !important;
  }

  .login-modal .content {
    .input-box,
    .btn-box {
      width: 100%;
    }

    .ivu-input {
      width: 100% !important;
    }
  }

  .register-modal .promise-box {
    width: 100%;
  }
}

.register-modal {
  .input-hint {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }
  .sms-input-row {
    display: flex;
    align-items: center;
  }
  .input-box {
    .require-box {
      display: flex;
      align-items: center;

      .require-icon {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ff2020;
        margin-left: 4px;
      }
    }
  }

  .btn-box {
    button {
      width: 100%;
      height: 100%;
    }
  }

  .promise-box {
    width: 304px;
    margin: 12px auto 0;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;

    span {
      color: #20a0ff;
    }
  }
}

/* 青少年模式弹窗 */
.teen-modal {
  .teen-form-row {
    display: flex;
    align-items: center;
    padding: 4px 0;
    font-size: 14px;
    color: #333;
  }

  .teen-form-label {
    white-space: nowrap;
    margin-right: 8px;
  }

  .teen-status-text {
    font-size: 14px;
    color: #555;
    line-height: 1.8;
  }
}

.artCon h1 {
  margin-bottom: 20px;
  font-size: 23px;
  height: 40px;
  line-height: 40px;
  font-weight: bold;
  text-align: center;
  margin-top: 30px;
}

.article {
  color: #666;
  font-family: 'Microsoft Yahei', 'PingFang SC', 'Lantinghei SC',
    'Hiragino Sans GB', 'Microsoft Sans Serif', 'WenQuanYi Micro Hei', sans;
  font-size: 18px;
  line-height: 36px;
  text-align: justify;
  white-space: normal;
}

.doc {
  padding: 20px 0 40px;
}
</style>
<script>
import axios from 'axios'
import Footer from './components/Footer'
import Report from './components/Report'

const api = axios.create({
  baseURL: 'https://c-api-test.vlebo.cn',
})

export default {
  components: { Footer, Report },
  data() {
    return {
      islogin: false,
      isregister: false,
      user: {
        name: '',
        password: '',
        isLogin: false,
        customerId: '',
        isAdult: false,
        trueName: '',
        mobile: '',
      },
      registerUser: {
        name: '',
        phoneNum: '',
        password: '',
        passwordA: '',
        smsCode: '',
        trueName: '',
        cardNum: '',
        isregister: '',
      },
      agree: false,
      showLoginPwd: false,
      showRegPwd: false,
      showRegPwdA: false,
      registerCountdown: 0,
      menuOpen: false,
      isTeenagerMode: false,
      isMinor: false,
      showOpenTeenModal: false,
      showTeenStatusModal: false,
      showCloseTeenModal: false,
      newPassword: '',
      closePassword: '',
    }
  },
  computed: {
    teenRemainingTime() {
      const used = Number(localStorage.getItem('viewDuration')) || 0
      const remaining = Math.max(40 * 60 - used, 0)
      const m = Math.floor(remaining / 60)
      const s = remaining % 60
      return m > 0 ? `${m}分钟${s > 0 ? s + '秒' : ''}` : `${s}秒`
    },
    navindex() {
      return this.$store.state.nav.navindex
    },
    activeNavIndex() {
      const routeName = this.$route.name
      const routeToNavMap = {
        index: 1,
        live: 2,
        detail: 2,
        find: 3,
        recommend: 4,
        vip: 5,
        about: 6,
      }

      return routeToNavMap[routeName] || this.navindex
    },
  },
  created() {
    const token = localStorage.getItem('token')
    if (token) {
      this.fetchUserInfo()
    } else {
      this.user.isLogin = false
    }
    // 初始化一次 seed，便于子页面在首次进入时对齐"账号态"
    if (!sessionStorage.getItem('liveListSeed')) {
      sessionStorage.setItem('liveListSeed', String(Date.now()))
    }
    // 从 localStorage 恢复青少年模式状态
    this.isTeenagerMode = localStorage.getItem('teenagerMode') === 'true'
    if (this.isTeenagerMode) {
      sessionStorage.setItem('teenagerMode', 'true')
    }
    if (this.$root && this.$root.$on) {
      this.$root.$on('teen-badge-click', this.handleTeenBadgeClick)
      this.$root.$on('logout', this.handleLogout)
      this.$root.$on('show-login', this.toLogin)
      this.$root.$on('teen-time-exceeded', this.handleTeenTimeExceeded)
    }
  },
  beforeDestroy() {
    if (this.$root && this.$root.$off) {
      this.$root.$off('teen-badge-click', this.handleTeenBadgeClick)
      this.$root.$off('logout', this.handleLogout)
      this.$root.$off('show-login', this.toLogin)
      this.$root.$off('teen-time-exceeded', this.handleTeenTimeExceeded)
    }
  },
  methods: {
    fetchUserInfo() {
      const token = localStorage.getItem('token')
      if (!token) {
        this.user.isLogin = false
        return
      }
      api.get('/wen/get-info', {
        headers: { Authorization: token },
      }).then((res) => {
        const resData = res.data
        if (resData.code !== 200) {
          this.user.isLogin = false
          localStorage.removeItem('token')
          sessionStorage.removeItem('userinfo')
          this.isTeenagerMode = false
          localStorage.removeItem('teenagerMode')
          localStorage.removeItem('supervisorPassword')
          this.$store.dispatch('getUser', {})
          return
        }
        const info = resData.data
        this.user.isLogin = true
        this.user.name = info.userName || this.user.name
        this.user.customerId = info.customerId || this.user.customerId
        this.user.isAdult = info.isAdult
        this.user.trueName = info.trueName
        this.user.mobile = info.mobile
        this.setMinorModeByIdCard(info.idCard)
        localStorage.setItem('viewDuration', info.viewDuration || 0)
        this.$setSession('userinfo', JSON.stringify(this.user))
        this.$store.dispatch('getUser', JSON.stringify(this.user))
        if (this.$root && this.$root.$emit) {
          this.$root.$emit('userinfo-updated')
        }
      }).catch(() => {
        this.user.isLogin = false
        localStorage.removeItem('token')
        sessionStorage.removeItem('userinfo')
        this.isTeenagerMode = false
        localStorage.removeItem('teenagerMode')
        localStorage.removeItem('supervisorPassword')
        this.$store.dispatch('getUser', {})
      })
    },
    bumpAccountSeed() {
      const seed = String(Date.now())
      sessionStorage.setItem('liveListSeed', seed)
      if (this.$root && this.$root.$emit) {
        this.$root.$emit('account-changed', seed)
      }
    },
    setMinorModeByIdCard(idCard) {
      if (!idCard || idCard.length < 14) {
        this.isMinor = false
        sessionStorage.removeItem('teenagerMode')
        localStorage.removeItem('teenagerMode')
        localStorage.removeItem('supervisorPassword')
        this.isTeenagerMode = false
        return
      }
      const birthYear = parseInt(idCard.substring(6, 10))
      const birthMonth = parseInt(idCard.substring(10, 12))
      const birthDay = parseInt(idCard.substring(12, 14))
      const now = new Date()
      let age = now.getFullYear() - birthYear
      if (now.getMonth() + 1 < birthMonth || (now.getMonth() + 1 === birthMonth && now.getDate() < birthDay)) {
        age--
      }
      if (age < 18) {
        this.isMinor = true
        sessionStorage.setItem('teenagerMode', 'true')
        localStorage.setItem('teenagerMode', 'true')
        this.isTeenagerMode = true
      } else {
        this.isMinor = false
        sessionStorage.removeItem('teenagerMode')
        localStorage.removeItem('teenagerMode')
        localStorage.removeItem('supervisorPassword')
        this.isTeenagerMode = false
      }
    },
    clearLoginSession() {
      const openerStorage =
        window.opener && Object.getOwnPropertyNames(window.opener).length > 0
          ? window.opener.sessionStorage
          : null
      if (openerStorage) {
        openerStorage.removeItem('userinfo')
        window.opener.localStorage.removeItem('token')
        openerStorage.removeItem('teenagerMode')
        openerStorage.setItem('liveListSeed', String(Date.now()))
      }
      sessionStorage.removeItem('userinfo')
      localStorage.removeItem('token')
      sessionStorage.removeItem('teenagerMode')
      localStorage.removeItem('teenagerMode')
      localStorage.removeItem('supervisorPassword')
      this.isTeenagerMode = false
      this.bumpAccountSeed()
    },
    handleTeenTimeExceeded() {
      this.showTeenStatusModal = true
    },
    handleTeenBadgeClick() {
      if (this.isTeenagerMode) {
        this.showTeenStatusModal = true
      } else if (this.isMinor) {
        sessionStorage.setItem('teenagerMode', 'true')
        localStorage.setItem('teenagerMode', 'true')
        this.isTeenagerMode = true
        this.showTeenStatusModal = true
      } else {
        this.newPassword = ''
        this.showOpenTeenModal = true
      }
    },
    confirmOpenTeenMode() {
      if (!this.newPassword) {
        this.$Message.warning('请设置监管人密码')
        return
      }
      localStorage.setItem('supervisorPassword', this.newPassword)
      localStorage.setItem('teenagerMode', 'true')
      sessionStorage.setItem('teenagerMode', 'true')
      this.isTeenagerMode = true
      this.showOpenTeenModal = false
      this.newPassword = ''
      this.bumpAccountSeed()
    },
    openCloseTeenModal() {
      if (this.isMinor) {
        this.$Message.warning('未成年人青少年模式不可解除')
        return
      }
      this.showTeenStatusModal = false
      this.closePassword = ''
      this.showCloseTeenModal = true
    },
    confirmCloseTeenMode() {
      if (this.isMinor) {
        this.$Message.warning('未成年人青少年模式不可解除')
        this.showCloseTeenModal = false
        return
      }
      const stored = localStorage.getItem('supervisorPassword')
      if (stored && this.closePassword !== stored) {
        this.$Message.error('密码错误，请重新输入')
        return
      }
      if (!stored && !this.closePassword) {
        this.$Message.warning('请输入监管人密码')
        return
      }
      localStorage.removeItem('teenagerMode')
      localStorage.removeItem('supervisorPassword')
      sessionStorage.removeItem('teenagerMode')
      this.isTeenagerMode = false
      this.showCloseTeenModal = false
      this.closePassword = ''
      this.bumpAccountSeed()
    },
    toLogin() {
      this.islogin = true
      this.user.name = ''
      this.user.password = ''
    },
    login() {
      if (!this.user.name) {
        this.$Message.warning('请输入用户名')
        return false
      }
      if (!this.user.password) {
        this.$Message.warning('请输入密码')
        return false
      }
      api.post('/wen/login', {
        userName: this.user.name,
        password: this.user.password,
      }).then((res) => {
        const resData = res.data
        if (resData.code !== 200) {
          this.$Message.warning(resData.msg || '登录失败')
          return
        }
        const data = resData.data
        localStorage.setItem('token', data.accessToken)
        this.islogin = false
        this.user.isLogin = true
        this.user.customerId = data.customerId
        this.user.isAdult = data.isAdult
        this.bumpAccountSeed()
        this.$store.dispatch('getUser', JSON.stringify(this.user))
        this.$store.dispatch('getXb', 10000)
        this.fetchUserInfo()
      }).catch((err) => {
        const msg = (err.response && err.response.data && err.response.data.msg) || '登录失败，请重试'
        this.$Message.warning(msg)
      })
    },
    logout() {
      this.menuOpen = false
      this.user.isLogin = false
      this.user.name = ''
      this.user.password = ''
      this.clearLoginSession()
      if (this.$route && this.$route.path !== '/index') {
        this.$router.push({ path: '/index' })
      }
    },
    handleLogout() {
      this.user.isLogin = false
      this.user.name = ''
      this.user.password = ''
      this.isTeenagerMode = false
      this.clearLoginSession()
    },
    sendRegisterSms() {
      const mobile = this.registerUser.phoneNum
      if (!mobile) {
        this.$Message.warning('请输入手机号')
        return
      }
      const phoneReg = /^[1][3-9]\d{9}$/
      if (!phoneReg.test(mobile)) {
        this.$Message.warning('请输入正确的手机号')
        return
      }
      api.post('/customer/send-sms', { mobile }).then((res) => {
        const resData = res.data
        if (resData.code !== 200) {
          this.$Message.warning(resData.msg || '发送失败')
          return
        }
        this.$Message.success('验证码已发送')
        this.registerCountdown = 60
        this.registerTimer = setInterval(() => {
          this.registerCountdown--
          if (this.registerCountdown <= 0) {
            clearInterval(this.registerTimer)
          }
        }, 1000)
      }).catch((err) => {
        const msg = (err.response && err.response.data && err.response.data.msg) || '发送失败，请重试'
        this.$Message.warning(msg)
      })
    },
    toRegister() {
      this.isregister = true
      this.registerUser.name = ''
      this.registerUser.phoneNum = ''
      this.registerUser.password = ''
      this.registerUser.passwordA = ''
      this.registerUser.smsCode = ''
      this.registerUser.trueName = ''
      this.registerUser.cardNum = ''
    },
    register() {
      if (!this.registerUser.name) {
        this.$Message.warning('请输入用户名')
        return false
      }
      const nameReg = /^[a-zA-Z0-9_]+$/
      if (!nameReg.test(this.registerUser.name)) {
        this.$Message.warning('用户名只能包含英文、数字和下划线')
        return false
      }
      if (!this.registerUser.phoneNum) {
        this.$Message.warning('请输入手机号')
        return false
      }
      const phoneReg = /^[1][3-9]\d{9}$/
      if (!phoneReg.test(this.registerUser.phoneNum)) {
        this.$Message.warning('请输入正确的手机号')
        return false
      }
      if (!this.registerUser.smsCode) {
        this.$Message.warning('请输入验证码')
        return false
      }

      if (!this.registerUser.password) {
        this.$Message.warning('请设置密码')
        return false
      }
      if (!this.registerUser.passwordA) {
        this.$Message.warning('请确认密码')
        return false
      }
      if (this.registerUser.password !== this.registerUser.passwordA) {
        this.$Message.warning('两次输入的密码不一致')
        return false
      }
      if (!this.registerUser.trueName) {
        this.$Message.warning('请输入身份证姓名')
        return false
      }
      if (!this.registerUser.cardNum) {
        this.$Message.warning('请输入身份证号')
        return false
      }
      const idreg =
        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (!idreg.test(this.registerUser.cardNum)) {
        this.$Message.warning('请输入正确的身份证号')
        return false
      }
      api.post('/wen/register', {
        userName: this.registerUser.name,
        password: this.registerUser.password,
        mobile: this.registerUser.phoneNum,
        code: Number(this.registerUser.smsCode),
        trueName: this.registerUser.trueName,
        idCard: this.registerUser.cardNum,
      }).then((res) => {
        const resData = res.data
        if (resData.code !== 200) {
          this.$Message.warning(resData.msg || '注册失败')
          return
        }
        const data = resData.data
        localStorage.setItem('token', data.accessToken)
        this.isregister = false
        this.user.isLogin = true
        this.user.name = this.registerUser.name
        this.user.customerId = data.customerId
        this.user.isAdult = data.isAdult
        this.setMinorModeByIdCard(this.registerUser.cardNum)
        this.bumpAccountSeed()
        this.$store.dispatch('getUser', JSON.stringify(this.user))
        this.$store.dispatch('getXb', 10000)
        this.fetchUserInfo()
        this.$Message.success('注册成功')
      }).catch((err) => {
        const msg = (err.response && err.response.data && err.response.data.msg) || '注册失败，请重试'
        this.$Message.warning(msg)
      })
    },
    toNext(path, index) {
      this.menuOpen = false
      this.$store.dispatch('getIndex', index)
      if (this.$route.path === path) {
        return false
      }
      this.$router.push({ path: path })
    },
  },
}
</script>
